// API URL configuration - uses production server API
// Use REACT_APP_API_BASE_URL environment variable to override (e.g., for local development)

const PRODUCTION_API_BASE_URL = 'https://api.whizpr.chat';

const envApiBaseUrl = process.env.REACT_APP_API_BASE_URL?.trim();
const isBrowserLocalhost =
  typeof window !== 'undefined' &&
  ['localhost', '127.0.0.1', '::1'].includes(window.location.hostname);

// Determine API base URL
// Priority: environment variable > local dev proxy > production API
const API_BASE_URL = envApiBaseUrl || (isBrowserLocalhost ? '' : PRODUCTION_API_BASE_URL);

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID?.trim() || '';

export const API_CONFIG = {
  baseURL: API_BASE_URL,
  chatHubURL: API_BASE_URL ? `${API_BASE_URL}/chatV2Hub` : '/chatV2Hub',
  googleClientId: GOOGLE_CLIENT_ID,
};

if (typeof window !== 'undefined') {
  console.log('API Configuration:', {
    baseURL: API_BASE_URL,
    googleClientId: GOOGLE_CLIENT_ID
      ? `${GOOGLE_CLIENT_ID.slice(0, 12)}...${GOOGLE_CLIENT_ID.slice(-27)}`
      : '',
    environment: process.env.NODE_ENV,
    hostname: window.location.hostname,
    protocol: window.location.protocol
  });
}

